// EditAdmin.tsx
import React, { useState } from "react";
import { Modal } from "@mantine/core";

import { PasswordInput, TextInput, Text, Button, Group, Select } from "@mantine/core";
import { RowDataAdmin } from "./types";

import classes from "./Admin.module.css";

interface EditAdminProps {
  isVisible: boolean;
  onClose: () => void;
  onSaveChanges: (editedAdmin: RowDataAdmin) => void;
  initialData: RowDataAdmin;
}

const EditAdmin: React.FC<EditAdminProps> = ({
  isVisible,
  onClose,
  onSaveChanges,
  initialData,
}) => {
  const [editedAdmin, setEditedAdmin] = useState<RowDataAdmin>(initialData);
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const handleSaveChanges = () => {
    onSaveChanges({
      ...editedAdmin,
      action: "Edit",
    });
  };

  return (
    <Modal
      opened={isVisible}
      onClose={onClose}
      size="md"
      padding="lg"
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Admin
        </div>
      }
    >
      <form onSubmit={handleSaveChanges}>
        {/* Display fields for editing */}
        <TextInput
          label="Name"
          placeholder="Enter admin name"
          mb="sm"
          value={editedAdmin.name}
          maxLength={255}
          onChange={(e) =>
            setEditedAdmin({ ...editedAdmin, name: e.currentTarget.value })
          }
        />

        <TextInput
          label="Email"
          placeholder="Enter admin email"
          mb="sm"
          value={editedAdmin.email}
          maxLength={255}
          onChange={(e) =>
            setEditedAdmin({ ...editedAdmin, email: e.currentTarget.value })
          }
        />

    <Select
        label="Admin Type"
        data={[{ value: 'admin', label: 'Admin' }, { value: 'manager', label: 'Manager' }, { value: 'content', label: 'Content' }, { value: 'price-list', label: 'Price List' }]}
        value={editedAdmin.role}
        onChange={(_value, option) => setEditedAdmin({...editedAdmin, role: option.value})}
        required
    />

        {/* <PasswordInput
          value={editedAdmin.password}
          maxLength={255}
          onChange={(event) =>
            setEditedAdmin({
              ...editedAdmin,
              password: event.currentTarget.value,
            })
          }
          placeholder="Your password"
          label="Password"
        />

        <PasswordInput
          value={editedAdmin.reenterPassword}
          maxLength={255}
          onChange={(event) => {
            setEditedAdmin({
              ...editedAdmin,
              reenterPassword: event.currentTarget.value,
            });
            setPasswordsMatch(
              editedAdmin.password === event.currentTarget.value
            );
          }}
          placeholder="Reenter your password"
          label="Reenter Password"
        /> */}

        {!passwordsMatch && (
          <Text color="red" mt="sm">
            Passwords do not match
          </Text>
        )}
        <Group className={classes.buttonBottom}>
          <Button onClick={() => onClose()} className={classes.buttonCancel}>
            Back
          </Button>
          <Button type="submit" className={classes.buttonSaveChanges}>
            Save Changes{" "}
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default EditAdmin;
